const getFilesRow = (item, index, showStatus, i18n) => (
    showStatus ?
        {
            id: index,
            fields: [{
                id: 'test',
                type: 'icon',
                iconClass: 'subtract-alt',
                iconType: 'light-tiny',
                colorScheme: 'secondary',
                variant: 'icon',
                stateName: 'visaRemoveRowIcon',
                i18n: { tooltipLabel: `${i18n.tooltipLabel} ${i18n.rowLabel} ${index + 1}` }
            },
            {
                type: 'staticField',
                value: item.fileName
            },
            {
                type: 'staticField',
                value: item.fileSize
            },
            {
                type: 'statusBadge',
                value: [
                    {
                        status: item.status.status,
                        value: item.status.displayName,
                        label: item.status.displayName
                    }
                ]
            }
            ]
        } : {
            id: index,
            fields: [{
                id: 'test',
                type: 'icon',
                iconClass: 'subtract-alt',
                iconType: 'light-tiny',
                colorScheme: 'secondary',
                variant: 'icon',
                stateName: 'visaRemoveRowIcon',
                i18n: { tooltipLabel: `${i18n.tooltipLabel} ${i18n.rowLabel} ${index + 1}` }
            },
            {
                type: 'staticField',
                value: item.fileName
            },
            {
                type: 'staticField',
                value: item.fileSize
            }]
        }
);

const getRows = (files, noFileMessage, showStatus, i18n) => {
    const rows = [];
    if (files && files.length > 0) {
        files.map((file, index) => (
            rows.push(getFilesRow(file, index, showStatus, i18n))
        ));
    } else {
        rows.push({
            id: 'no_file',
            fields: [
                {
                    type: 'staticField',
                    value: noFileMessage
                }
            ]
        }
        );
    }
    return rows;
};

export default getRows;
